<template>
  <div id="home">
    <div v-if="!_.isEmpty(userData) && !userData.have_password" class="alert alert-danger alert-dismissible fade show" role="alert">
      <strong class="text-danger">Cảnh báo bảo mật!</strong> Mật khẩu của bạn hiện đang trống, vui lòng
      <a :href="route('addpassword', website.domain)">[bấm vào đây]</a>
      để cập nhật mật khẩu mới!.
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <nav class="navbar navbar-expand-lg navbar-dark">
      <div class="container">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" @click="isMenuMobileActive = !isMenuMobileActive">
          <span class="navbar-toggler-icon"></span>
        </button>
          <deposit-via-phone-card
              :website="website"
              :settings="settings"
          >
          </deposit-via-phone-card>

<!--          <deposit-via-atm
              :website="website"
              :settings="settings"
          >
          </deposit-via-atm>

          <deposit-via-momo
              :website="website"
              :settings="settings"
          >
          </deposit-via-momo>-->
        <div class="collapse navbar-collapse" :class="isMenuMobileActive ? 'd-none' : ''" id="navbarSupportedContent">
          <ul class="navbar-nav mr-auto">
            <li class="nav-item active">
              <a class="nav-link" :href="route('home', { domain: website.domain })">TRANG CHỦ
                <span class="sr-only">(current)</span>
              </a>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link" href="#">NẠP TIỀN
                <span class="sr-only">(current)</span>
              </a>
              <div class="dropdown-content" style="min-width: 230px">
                <a :hidden="false" class="text-white" href="#depositViaPhoneCardModal" data-toggle="modal" data-target="#depositViaPhoneCardModal">NẠP QUA THẺ ĐIỆN THOẠI</a>
                <a :hidden="true" class="text-white" href="#depositViaATM" data-toggle="modal" data-target="#depositViaATM">NẠP QUA ATM <span v-if="settings.discount_atm > 0">TẶNG {{ settings.discount_atm }}%</span></a>
                <a :hidden="true" class="text-white" href="#depositViaMOMO" data-toggle="modal" data-target="#depositViaMOMO">NẠP QUA MOMO <span v-if="settings.discount_momo > 0"> TẶNG {{ settings.discount_momo }}%</span></a>
              </div>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link" href="#">LỊCH SỬ
                <span class="sr-only">(current)</span>
              </a>
              <div class="dropdown-content">
                <a class="text-white" :href="route('lsnap', website.domain)">LỊCH SỬ NẠP THẺ</a>
                <a class="text-white" :href="route('lsmua', website.domain)">LỊCH SỬ MUA NICK</a>
                <a class="text-white" :href="route('randomHistory', website.domain)">LỊCH SỬ MUA RANDOM</a>
                <a class="text-white" :href="route('lswheel', website.domain)">LỊCH SỬ VÒNG QUAY</a>
                <a class="text-white" :href="route('fe.transaction.withdraw', website.domain)">LỊCH SỬ RÚT QUÀ</a>
              </div>
            </li>
            <li class="nav-item dropdown">
              <a class="nav-link" :href="route('fe_blog', website.domain)">HƯỚNG DẪN
                <span class="sr-only">(current)</span>
              </a>
              <div class="dropdown-content" style="min-width: 230px">
                <a class="text-white" href="/blogs/huong-dan-mua-tai-khoan-game-tai-website.html" >Hướng dẫn mua acc</a>
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link" :href="'https://fb.com/' + website.facebook" target="_blank"><i class="fas fa-headset"></i> Hỗ Trợ<span class="sr-only">(current)</span>
              </a>
            </li>
          </ul>
          <div class="right__login" href="#">
            <div class="right__login--icon">
              <i class="fas fa-user-circle"></i>
            </div>
            <div class="right__login--text" v-if="!_.isEmpty(userData)" v-b-toggle.sidebar-variant>
              {{ user.name }} - ID: {{ user.id }}
            </div>
            <div style="cursor: pointer;" @click="redirectToLoginPage()" class="right__login--text" v-else>
              ĐĂNG NHẬP
            </div>
          </div>
        </div>
      </div>
    </nav>
    <b-sidebar  v-if="!_.isEmpty(userData)"
                id="sidebar-variant"
                bg-variant="dark"
                text-variant="light"
                title="Thông tin cá nhân"
                backdrop-variant="dark"
                backdrop
                right
                shadow>
      <div class="px-3 py-2" v-lazy-container="{ selector: 'img' }">
          <div class="p-3">
              <p class="text-danger">
                  Số Dư: {{   Helper.formatMoney(user.cash)  }} <sup>vnd</sup>
              </p>
              <nav class="mb-3">
                  <b-nav vertical>
                      <b-nav-item :href="route('userfe', { domain : website.domain })">
                          <span class="text-white">
                              <i class="fas fa-bars"></i> Thông tin tài khoản
                          </span>
                      </b-nav-item>
                      <b-nav-item :href="route('addpassword', website.domain)">
                          <span class="text-white">
                              <i class="fas fa-lock"></i> Đổi mật khẩu
                          </span>
                      </b-nav-item>
                      <b-nav-item href="/logout">
                          <span class="text-danger">
                              <i class="fas fa-sign-out-alt"></i> Đăng xuất
                          </span>
                      </b-nav-item>
<!--                      <b-nav-item href="#link-1" @click="hide">Link</b-nav-item>-->
<!--                      <b-nav-item href="#link-2" @click="hide">Another Link</b-nav-item>-->
                  </b-nav>
              </nav>
          </div>
<!--        <b-img data-src="https://picsum.photos/500/500/?image=54" fluid thumbnail></b-img>-->
      </div>
    </b-sidebar>
    <a class="back-to-top" v-scroll-to="'#home'">
			<span class="wrapper-btn">
				<i class="fas fa-angle-double-up"></i>
			</span>
    </a>
  </div>
</template>
<script>
export default {
    props: {
    user: {
      Type: Object,
      default() {
        return {};
      }
    },
    website: {
      Type: Object,
      default() {
        return {};
      }
    },
    settings: {
      Type: Object,
      default() {
          return {};
      }
    },
  },
  data() {
    return {
      userData: this._.clone(this.user),
      isMenuMobileActive: false,
    }
  },
  methods: {
      redirectToLoginPage() {
          window.location = '/login';
      },
  }
}
</script>
